import { render, staticRenderFns } from "./cloudStoreOpenAudit.vue?vue&type=template&id=20313c52"
import script from "./cloudStoreOpenAudit.vue?vue&type=script&lang=js"
export * from "./cloudStoreOpenAudit.vue?vue&type=script&lang=js"
import style0 from "./cloudStoreOpenAudit.vue?vue&type=style&index=0&id=20313c52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports